"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { GraduationCap, Building2, ArrowRight, BookOpen, Globe, ShieldCheck, History } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Benvenuto() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const stats = [{
    label: "Anni di Esperienza",
    value: "15+",
    icon: <History className="w-5 h-5 text-primary" />
  }, {
    label: "Paesi Coperti",
    value: "120+",
    icon: <Globe className="w-5 h-5 text-primary" />
  }, {
    label: "Conformità Legale",
    value: "100%",
    icon: <ShieldCheck className="w-5 h-5 text-primary" />
  }];
  return <section data-section-id="247264" id="hub-della-mobilità-accademica" className="relative w-full bg-background py-12 md:py-16 lg:py-20 overflow-hidden flex items-center justify-center dark">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/premium_academic_architecture.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/premium_academic_architecture.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/premium_academic_architecture.png-wvc-sizes" alt="Premium Academic Mobility" className="w-full h-full object-cover opacity-15 scale-105 transition-transform duration-[20000ms] ease-linear" loading="lazy" decoding="async" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/95 to-background/80 z-10"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_30%,var(--color-primary)_0%,transparent_70%)] opacity-[0.03] z-10"></div>
      </div>

      <div ref={ref} className={`relative z-20 container mx-auto px-6 md:px-12 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid lg:grid-cols-12 gap-16 items-center">
          {}
          <div className="lg:col-span-7 flex flex-col items-start text-left">
            <Badge variant="outline" className="mb-10 px-5 py-2 text-[11px] uppercase tracking-[0.3em] font-mono rounded-lg border-primary/40 bg-primary/5 text-primary shadow-sm">
              <BookOpen className="w-3.5 h-3.5 mr-2" />
              Institutional Excellence
            </Badge>

            <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-extrabold tracking-tighter text-foreground mb-10 leading-[1.05]">
              Il Tuo Ponte Verso il <br />
              <span className="text-accent italic">Successo Globale</span>
            </h1>

            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mb-14 leading-relaxed font-sans font-light">
              Supporto dedicato a studenti, istituti e programmi educativi internazionali nella gestione di procedure consolari, documentazione accademica e pratiche di mobilità internazionale, con assistenza professionale per percorsi formativi all’estero e in Italia.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-6 w-full sm:w-auto">
              <Button asChild variant="default" size="lg" className="w-full sm:w-auto rounded-lg px-16 h-20 text-lg font-bold transition-all shadow-lg hover:scale-[1.02] active:scale-95 bg-[#FFC829] hover:bg-[#FFC829]/90 text-primary">
                <Link to="/VistiPerStudioStudentiPage">
                  <GraduationCap className="w-6 h-6 mr-2" />
                  Area Studenti
                </Link>
              </Button>
              
              <Button asChild variant="default" size="lg" className="w-full sm:w-auto rounded-lg px-16 h-20 text-lg font-bold transition-all shadow-lg hover:scale-[1.02] active:scale-95 bg-[#FFC829] hover:bg-[#FFC829]/90 text-primary">
                <Link to="/VisasForGroupsAndSchoolTripsPage">
                  <Building2 className="w-6 h-6 mr-2" />
                  Area Istituti
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative">
            <div className="relative bg-white/5 backdrop-blur-2xl border border-primary/20 p-10 md:p-14 rounded-lg shadow-2xl overflow-hidden group">
              {}
              <div className="absolute -top-24 -right-24 w-64 h-64 bg-primary/10 blur-[100px] rounded-lg group-hover:bg-primary/20 transition-colors duration-1000"></div>
              
              <div className="space-y-12 relative z-10">
                {stats.map((stat, i) => <div key={i} data-index={i} className="flex items-center gap-8 group/item">
                    <div className="flex-shrink-0 w-16 h-16 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center group-hover/item:bg-primary/20 transition-all duration-500 group-hover/item:scale-110">
                      {stat.icon}
                    </div>
                    <div>
                      <div className="text-4xl font-bold text-foreground font-serif tracking-tight">
                        {stat.value}
                      </div>
                      <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground font-mono mt-2">
                        {stat.label}
                      </div>
                    </div>
                  </div>)}
              </div>

              <div className="mt-14 pt-10 border-t border-primary/10">
                <p className="text-sm text-muted-foreground/80 italic font-sans leading-relaxed">
                  "Garantiamo la massima conformità normativa per ogni percorso di mobilità internazionale, elevando gli standard della consulenza accademica."
                </p>
              </div>
            </div>
            
            {}
            <div className="absolute -bottom-8 -left-8 w-32 h-32 border-l border-b border-primary/30 rounded-lg hidden lg:block"></div>
            <div className="absolute -top-8 -right-8 w-16 h-16 border-t border-r border-primary/30 rounded-lg hidden lg:block"></div>
          </div>
        </div>
      </div>
    </section>;
}